module.exports = __webpack_public_path__ + "img/02zs.0eaa1c2d.png";